import ApplicationBar from "../components/ApplicationBar";

import React, {useEffect, useState} from "react";
import {Outlet} from "react-router";
import {
    MsalAuthenticationTemplate
} from "@azure/msal-react";

import {InteractionType} from '@azure/msal-browser';
import Grid from "@mui/material/Grid2";
import {createTheme, SelectChangeEvent, ThemeProvider, useTheme} from "@mui/material";
import * as locales from '@mui/material/locale';
import i18n from "i18next";

type SupportedLocales = keyof typeof locales;

export default function Root() {
    const [muiLocale, setMuiLocale] = React.useState<SupportedLocales>('enUS');
    const theme = useTheme();
    const [locale, setLocale] = useState('en-US');

    useEffect(() => {
        i18n.changeLanguage(locale);
        const newLocale = locale.substring(0, 2) + locale.substring(3, 5) as SupportedLocales;
        setMuiLocale(newLocale);
        document.title = 'CALI';
    }, [locale]);

    function handleLocaleChange(event: SelectChangeEvent<String>) {
        const localString = event.target.value.toString();
        setLocale(localString);
    }

    const localisedTheme = React.useMemo(
        () => createTheme(theme, locales[muiLocale]),
        [muiLocale, locale, theme],
    );

    return (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
            <ThemeProvider theme={localisedTheme}>
                <ApplicationBar locale={locale} onLocaleSwitched={handleLocaleChange} />
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <Outlet/>
                    </Grid>
                </Grid>
            </ThemeProvider>
         </MsalAuthenticationTemplate>
    );
}